import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css/bundle';

export default () => {

	const els = [...document.querySelectorAll('.awards')]
	els.map(el => {

		const carouselEl = el.querySelector('.awards__cont')
		const carouselNavigation = el.querySelector('.logo-carousel__pagination')
		if (!carouselEl) return null

		return new Swiper(carouselEl, {
			modules: [ Pagination, Autoplay, Navigation ],
			speed: 750,
			slidesPerView: 1.15,
			slidesPerGroup: 1,
			loop: true,
			// autoplay: {
			// 	delay: 4000,
			// 	disableOnInteraction: false,
			// },
            navigation : {
                nextEl: '.awards-nav__right',
                prevEl: '.awards-nav__left'
            },
			pagination: {
				el: carouselNavigation,
				dynamicBullets: false,
				clickable: true,
			},
			breakpoints: {
				780: { 
					slidesPerView: 2.7,
					slidesPerGroup: 1
                },
				1124: { 
					slidesPerView: 3.5,
					slidesPerGroup: 1
                },
				1750: { 
					slidesPerView: 3.8,
					slidesPerGroup: 1
                },

                2500: { 
					slidesPerView: 5,
					slidesPerGroup: 1
                },
			},
		})
	})
}